import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'

const { location } = window;
if (
    process.env.VUE_APP_ENV !== 'development'
    && location.protocol !== 'https:'
) {
    location.replace(location.href.replace(/^http:/, 'https:'));
}

Vue.config.productionTip = false

Vue.use(Vuelidate)
Vue.use(VueMeta)
Vue.use(PortalVue)

Vue.config.devtools = true

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app')
